<template>
  <div class="inspection-task-details-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('inspectionTaskDetails.page.title')"
      :subtitle="$t('inspectionTaskDetails.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-download" @click="exportExcel">
          {{ $t('inspectionTaskDetails.export') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) SearchPanel -->
    <ds-search-panel>
      <el-row :gutter="16">
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-input v-model.trim="inspectionTaskDetailManageInfo.conditions.planUserName" clearable class="w-full"
            :placeholder="$t('inspectionTaskDetails.inputInspector')" @keyup.enter.native="queryInspectionTaskMethod" />
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-date-picker v-model="inspectionTaskDetailManageInfo.conditions.inspectionStartTime" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" class="w-full"
            :placeholder="$t('inspectionTaskDetails.inputStartTime')" />
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-date-picker v-model="inspectionTaskDetailManageInfo.conditions.inspectionEndTime" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" class="w-full"
            :placeholder="$t('inspectionTaskDetails.inputEndTime')" />
        </el-col>
      </el-row>

      <!-- 高级筛选：展开 / 收起 -->
      <el-row v-show="inspectionTaskDetailManageInfo.moreCondition" :gutter="16" class="ds-more-row">
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-select v-model="inspectionTaskDetailManageInfo.conditions.inspectionPlanId" clearable class="w-full"
            :placeholder="$t('inspectionTaskDetails.selectInspectionPlan')">
            <el-option v-for="(item, index) in inspectionTaskDetailManageInfo.inspectionPlanList" :key="index"
              :label="item.inspectionPlanName" :value="item.inspectionPlanId" />
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-select v-model="inspectionTaskDetailManageInfo.conditions.inspectionRouteId" clearable class="w-full"
            :placeholder="$t('inspectionTaskDetails.selectInspectionRoute')">
            <el-option v-for="(item, index) in inspectionTaskDetailManageInfo.inspectionRouteList" :key="index"
              :label="item.routeName" :value="item.inspectionRouteId" />
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-select v-model="inspectionTaskDetailManageInfo.conditions.inspectionId" clearable class="w-full"
            :placeholder="$t('inspectionTaskDetails.selectInspectionPoint')">
            <el-option v-for="(item, index) in inspectionTaskDetailManageInfo.inspectionPointList" :key="index"
              :label="item.inspectionName" :value="item.inspectionId" />
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-input v-model.trim="inspectionTaskDetailManageInfo.conditions.taskDetailId" clearable class="w-full"
            :placeholder="$t('inspectionTaskDetails.inputTaskDetailId')" />
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-select v-model="inspectionTaskDetailManageInfo.conditions.inspectionState" clearable class="w-full"
            :placeholder="$t('inspectionTaskDetails.selectSignStatus')">
            <el-option v-for="(item, index) in inspectionTaskDetailManageInfo.inspectionStateTypes" :key="index"
              :label="item.name" :value="item.statusCd" />
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-select v-model="inspectionTaskDetailManageInfo.conditions.state" clearable class="w-full"
            :placeholder="$t('inspectionTaskDetails.selectInspectionPointStatus')">
            <el-option v-for="(item, index) in inspectionTaskDetailManageInfo.stateTypes" :key="index"
              :label="item.name" :value="item.statusCd" />
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-select v-model="inspectionTaskDetailManageInfo.conditions.taskState" clearable class="w-full"
            :placeholder="$t('inspectionTaskDetails.selectTaskStatus')">
            <el-option v-for="(item, index) in inspectionTaskDetailManageInfo.taskStates" :key="index"
              :label="item.name" :value="item.statusCd" />
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-select v-model="inspectionTaskDetailManageInfo.conditions.patrolType" clearable class="w-full"
            :placeholder="$t('inspectionTaskDetails.selectPatrolStatus')">
            <el-option v-for="(item, index) in inspectionTaskDetailManageInfo.patrolTypes" :key="index"
              :label="item.name" :value="item.statusCd" />
          </el-select>
        </el-col>
      </el-row>

      <template #actions>
        <el-button type="text" icon="el-icon-more" @click="toggleMoreCondition">
          {{ inspectionTaskDetailManageInfo.moreCondition ? $t('inspectionTaskDetails.hide') :
            $t('inspectionTaskDetails.more') }}
        </el-button>
        <el-button type="primary" icon="el-icon-search" @click="queryInspectionTaskMethod">
          {{ $t('inspectionTaskDetails.search') }}
        </el-button>
        <el-button icon="el-icon-refresh-left" @click="resetInspectionTaskMethod">
          {{ $t('inspectionTaskDetails.reset') }}
        </el-button>
      </template>
    </ds-search-panel>

    <!-- (3)(4)(6) Toolbar + DataTable + PaginationBar -->
    <div class="ds-panel">
      <ds-toolbar :total="inspectionTaskDetailManageInfo.total" :density="density" :show-column-setting="false"
        :show-refresh="true" @update:density="density = $event" @refresh="listInspectionTasksDetailList">
        <template #left>
          <span class="ds-panel__title">{{ $t('inspectionTaskDetails.inspectionDetails') }}</span>
        </template>
      </ds-toolbar>

      <ds-data-table :data="inspectionTaskDetailManageInfo.inspectionTasks" :loading="loading" :error="hasError"
        :error-message="errorMessage" :density="density" border
        :empty-description="$t('inspectionTaskDetails.page.empty')" @retry="listInspectionTasksDetailList">
        <el-table-column prop="taskDetailId" :label="$t('inspectionTaskDetails.taskDetailId')" align="center" width="150">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.taskDetailId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionName" :label="$t('inspectionTaskDetails.inspectionPointName')" align="left"
          min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.inspectionName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="inspectionPlanName" :label="$t('inspectionTaskDetails.inspectionPlanName')" align="left"
          min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.inspectionPlanName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="routeName" :label="$t('inspectionTaskDetails.inspectionRouteName')" align="left"
          min-width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.routeName || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('inspectionTaskDetails.inspector')" align="center" width="180">
          <template slot-scope="scope">
            <div class="ds-time-cell">
              <span class="ds-num">{{ scope.row.planInsTime || '-' }}</span>
              <span class="ds-num">{{ scope.row.planEndTime || '-' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('inspectionTaskDetails.inspectionPoint')" align="center" width="180">
          <template slot-scope="scope">
            <div class="ds-time-cell">
              <span class="ds-num">{{ scope.row.pointStartTime || '-' }}</span>
              <span class="ds-num">{{ scope.row.pointEndTime || '-' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionTime" :label="$t('inspectionTaskDetails.actualInspectionTime')" align="center"
          width="170">
          <template slot-scope="scope">
            <span class="ds-num">{{ formatDateTimeSec(scope.row.inspectionTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('inspectionTaskDetails.actualSignStatus')" align="center" width="130">
          <template slot-scope="scope">
            <ds-status-tag :type="resolveSignState(scope.row)" :label="scope.row.inspectionStateName || '-'" />
          </template>
        </el-table-column>
        <el-table-column prop="planUserName" :label="$t('inspectionTaskDetails.plannedInspector')" align="center" width="110">
          <template slot-scope="scope">
            {{ scope.row.planUserName || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('inspectionTaskDetails.actualInspector')" align="center" width="110">
          <template slot-scope="scope">
            {{ scope.row.actUserName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="signTypeName" :label="$t('inspectionTaskDetails.inspectionMethod')" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.signTypeName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="taskStateName" :label="$t('inspectionTaskDetails.taskStatus')" align="center" width="120">
          <template slot-scope="scope">
            <ds-status-tag :type="resolveTaskState(scope.row)" :label="scope.row.taskStateName || '-'" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('inspectionTaskDetails.inspectionPointStatus')" align="center" width="130">
          <template slot-scope="scope">
            <ds-status-tag :type="resolvePointState(scope.row)" :label="scope.row.stateName || '-'" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('inspectionTaskDetails.patrolStatus')" align="left" min-width="140"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="ds-text-muted">{{ scope.row.description || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('inspectionTaskDetails.inspectionPhotos')" align="center" width="120">
          <template slot-scope="scope">
            <span v-for="_photo in scope.row.photos" :key="_photo.url">
              <el-image class="ds-thumb" :src="_photo.url" :preview-src-list="[_photo.url]" fit="cover" />
            </span>
            <span v-if="!scope.row.photos || !scope.row.photos.length" class="ds-text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('inspectionTaskDetails.createTime')" align="center" width="170">
          <template slot-scope="scope">
            <span class="ds-num">{{ formatDateTimeSec(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('inspectionTaskDetails.locationInfo')" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="openMap(scope.row.latitude, scope.row.longitude)">
              {{ $t('inspectionTaskDetails.view') }}
            </el-button>
          </template>
        </el-table-column>
      </ds-data-table>

      <ds-pagination-bar :total="inspectionTaskDetailManageInfo.total"
        :page="inspectionTaskDetailManageInfo.conditions.page" :size="inspectionTaskDetailManageInfo.conditions.row"
        :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
        <template #summary>
          <span class="ds-tip-text">{{ $t('inspectionTaskDetails.page.tip') }}</span>
        </template>
      </ds-pagination-bar>
    </div>

    <view-map ref="viewMap"></view-map>
    <view-image ref="viewImage"></view-image>
  </div>
</template>

<script>
import { listInspectionTaskDetails, exportInspectionTaskDetails,listInspectionPlans,listInspectionRoutes,listInspectionPoints } from '@/api/inspection/inspectionTaskDetailsApi'
import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import ViewMap from '@/components/system/ViewMap'
import ViewImage from '@/components/system/viewImage'
import { formatDateTimeSec } from '@/utils/format'
import { resolveStatus } from '@/utils/statusMap'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsSearchPanel from '@/components/ds/ds-search-panel.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'

export default {
  name: 'InspectionTaskDetailsList',
  components: {
    ViewMap,
    ViewImage,
    DsPageHeader,
    DsSearchPanel,
    DsToolbar,
    DsDataTable,
    DsStatusTag,
    DsPaginationBar
  },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      inspectionTaskDetailManageInfo: {
        inspectionTasks: [],
        total: 0,
        records: 1,
        moreCondition: false,
        stateTypes: [],
        inspectionStateTypes: [],
        taskStates: [],
        patrolTypes: [],
        inspectionPointList: [],
        inspectionPlanList: [],
        inspectionRouteList: [],
        conditions: {
          planUserName: '',
          taskDetailId: '',
          inspectionPlanName: '',
          inspectionStartTime: '',
          inspectionEndTime: '',
          state: '',
          inspectionState: '',
          inspectionId: '',
          inspectionPlanId: '',
          inspectionRouteId: '',
          taskState: '',
          patrolType: '',
          page: 1,
          row: 10,
          communityId: ''
        }
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.initData()
  },
  methods: {
    async initData() {
      this.loading = true
      try {
        await this.getDictData()
        await this.listInspectionTasksDetailList()
        await this.listInspectionPlanInfo()
        await this.listInspectionRouteInfo()
        await this.listInspectionPointInfo()
      } catch (error) {
        console.error('初始化数据失败:', error)
        this.$message.error(this.$t('common.error'))
      } finally {
        this.loading = false
      }
    },

    async getDictData() {
      try {
        const [stateTypes, inspectionStateTypes, taskStates, patrolTypes] = await Promise.all([
          getDict('inspection_task', 'state'),
          getDict('inspection_task_detail', 'inspection_state'),
          getDict('inspection_task_detail', 'state'),
          getDict('inspection_task_detail', 'patrol_type')
        ])

        this.inspectionTaskDetailManageInfo.stateTypes = stateTypes || []
        this.inspectionTaskDetailManageInfo.inspectionStateTypes = inspectionStateTypes || []
        this.inspectionTaskDetailManageInfo.taskStates = taskStates || []
        this.inspectionTaskDetailManageInfo.patrolTypes = patrolTypes || []
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },

    async listInspectionTasksDetailList() {
      this.loading = true
      this.hasError = false
      this.errorMessage = ''
      try {
        this.inspectionTaskDetailManageInfo.conditions.communityId = this.communityId
        const res = await listInspectionTaskDetails(this.inspectionTaskDetailManageInfo.conditions)
        this.inspectionTaskDetailManageInfo.total = res.total || 0
        this.inspectionTaskDetailManageInfo.records = res.records || 0
        this.inspectionTaskDetailManageInfo.inspectionTasks = Array.isArray(res.inspectionTaskDetails)
          ? res.inspectionTaskDetails
          : []
      } catch (error) {
        console.error('获取巡检任务明细列表失败:', error)
        this.hasError = true
        this.errorMessage = this.$t('inspectionTaskDetails.page.loadFailed')
        this.$message.error(this.$t('common.error'))
      } finally {
        this.loading = false
      }
    },

    async listInspectionPlanInfo() {
      try {
        const params = {
          communityId: this.communityId,
          page: 1,
          row: 200
        }
        const res = await listInspectionPlans(params)
        this.inspectionTaskDetailManageInfo.inspectionPlanList = Array.isArray(res.data) ? res.data : []
      } catch (error) {
        console.error('获取巡检计划列表失败:', error)
      }
    },

    async listInspectionRouteInfo() {
      try {
        const params = {
          communityId: this.communityId,
          page: 1,
          row: 200
        }
        const res = await listInspectionRoutes(params)
        this.inspectionTaskDetailManageInfo.inspectionRouteList = Array.isArray(res.inspectionRoutes)
          ? res.inspectionRoutes
          : []
      } catch (error) {
        console.error('获取巡检路线列表失败:', error)
      }
    },

    async listInspectionPointInfo() {
      try {
        const params = {
          communityId: this.communityId,
          page: 1,
          row: 200
        }
        const res = await listInspectionPoints(params)
        this.inspectionTaskDetailManageInfo.inspectionPointList = Array.isArray(res.inspectionPoints)
          ? res.inspectionPoints
          : []
      } catch (error) {
        console.error('获取巡检点列表失败:', error)
      }
    },

    queryInspectionTaskMethod() {
      this.inspectionTaskDetailManageInfo.conditions.page = 1
      this.listInspectionTasksDetailList()
    },

    resetInspectionTaskMethod() {
      this.inspectionTaskDetailManageInfo.conditions = {
        planUserName: '',
        taskDetailId: '',
        inspectionPlanName: '',
        inspectionStartTime: '',
        inspectionEndTime: '',
        state: '',
        inspectionState: '',
        inspectionId: '',
        inspectionPlanId: '',
        inspectionRouteId: '',
        taskState: '',
        patrolType: '',
        page: 1,
        row: 10,
        communityId: this.communityId
      }
      this.listInspectionTasksDetailList()
    },

    toggleMoreCondition() {
      this.inspectionTaskDetailManageInfo.moreCondition = !this.inspectionTaskDetailManageInfo.moreCondition
    },

    handleSizeChange(val) {
      this.inspectionTaskDetailManageInfo.conditions.row = val
      this.inspectionTaskDetailManageInfo.conditions.page = 1
      this.listInspectionTasksDetailList()
    },

    handleCurrentChange(val) {
      this.inspectionTaskDetailManageInfo.conditions.page = val
      this.listInspectionTasksDetailList()
    },

    openFile(photo) {
      this.$refs.viewImage.open(photo.url)
    },

    openMap(lat, lng) {
      this.$refs.viewMap.open({ lat: lat, lng: lng })
    },

    async exportExcel() {
      try {
        const params = {
          ...this.inspectionTaskDetailManageInfo.conditions,
          pagePath: 'inspectionTaskDetails'
        }
        const res = await exportInspectionTaskDetails(params)
        if (res.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          // 这里需要根据实际项目调整跳转逻辑
          this.$router.push({ path: '/pages/property/downloadTempFile', query: { tab: this.$t('common.downloadCenter') } })
        } else {
          this.$message.error(res.msg || this.$t('common.exportFail'))
        }
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error(this.$t('common.exportFail'))
      }
    },

    /**
     * 实际签到状态：60000 为已签到（正常），其余为异常
     */
    resolveSignState(row) {
      if (!row) return 'muted'
      if (row.inspectionState === '60000') return 'success'
      return 'danger'
    },

    /**
     * 任务状态（inspection_task 域）
     */
    resolveTaskState(row) {
      if (!row) return 'muted'
      const resolved = resolveStatus(row.taskState, {
        domain: 'inspectionTask',
        text: row.taskStateName || '',
        fallbackLabel: row.taskStateName || ''
      })
      return resolved.type
    },

    /**
     * 巡检点状态：20200408 已超时为危险态，其余按文案语义推断
     */
    resolvePointState(row) {
      if (!row) return 'muted'
      if (row.state === '20200408') return 'danger'
      const resolved = resolveStatus(row.state, {
        domain: 'inspectionTask',
        text: row.stateName || '',
        fallbackLabel: row.stateName || ''
      })
      return resolved.type
    },

    formatDateTimeSec(value) {
      return formatDateTimeSec(value)
    }
  }
}
</script>

<style lang="scss" scoped>
.inspection-task-details-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 表格 + 分页 组成的白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

/* 高级筛选区与首行之间的间距 */
.ds-more-row {
  margin-top: var(--ds-spacing-md);
}

/* 分页条左侧提示文案 */
.ds-tip-text {
  font-size: var(--ds-font-size-xs);
  color: var(--ds-gray-500);
  line-height: 1.6;
}

/* 起止时间上下两行 */
.ds-time-cell {
  display: flex;
  flex-direction: column;
  line-height: 1.6;

  .ds-num {
    font-size: var(--ds-font-size-xs);
  }
}

/* 辅助文本 */
.ds-text-muted {
  color: var(--ds-gray-500);
}

/* 缩略图 */
.ds-thumb {
  width: 48px;
  height: 48px;
  margin-right: 4px;
  border-radius: var(--ds-radius-sm);
}
</style>
